import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar");

  const _component_van_tab = _resolveComponent("van-tab");

  const _component_van_tabs = _resolveComponent("van-tabs");

  const _component_router_view = _resolveComponent("router-view");

  return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_van_nav_bar, {
    title: "数说德源"
  }), _createVNode(_component_van_tabs, {
    active: $options.activeMenu,
    "onUpdate:active": _cache[0] || (_cache[0] = $event => $options.activeMenu = $event)
  }, {
    default: _withCtx(() => [_createVNode(_component_van_tab, {
      title: "人",
      name: "人",
      to: "/cart/user"
    }), _createVNode(_component_van_tab, {
      title: "事",
      name: "事",
      to: "/cart/thing"
    }), _createVNode(_component_van_tab, {
      title: "物",
      name: "物",
      to: "/cart/goods"
    }), _createVNode(_component_van_tab, {
      title: "组织",
      name: "组织",
      to: "/cart/org"
    })]),
    _: 1
  }, 8, ["active"]), _createVNode(_component_router_view)]);
}